import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HERO_IMAGE } from "@/lib/content";

export default function Hero() {
  return (
    <section
      data-testid="home-hero"
      className="relative min-h-[92vh] w-full overflow-hidden bg-ink"
    >
      <img
        src={HERO_IMAGE}
        alt="Sunshine Coast beach at golden hour"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="hero-overlay absolute inset-0" />

      <div className="container-narrow relative z-10 flex min-h-[92vh] flex-col justify-end pb-24 pt-44 md:pb-32">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <span
            data-testid="hero-eyebrow"
            className="text-[11px] font-medium uppercase tracking-[0.32em] text-white/85"
          >
            Bellhouse Law – Sunshine Coast
          </span>
          <h1
            data-testid="hero-headline"
            className="mt-6 text-5xl font-bold leading-[1.02] text-white sm:text-6xl md:text-7xl lg:text-[92px]"
            aria-label="Practical advice, proven results."
          >
            Practical advice,
            <br />
            <span className="italic font-semibold text-sage-200">
              proven results.
            </span>
          </h1>
          <p
            data-testid="hero-supporting-copy"
            className="mt-8 max-w-2xl text-lg leading-relaxed text-white/90"
          >
            Clear, responsive and commercially practical legal advice for
            individuals, businesses and developers, simplifying property and
            commercial transactions across the coast and beyond.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/contact"
              data-testid="hero-enquire-cta"
              className="btn-primary"
            >
              Make an Enquiry <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
